import type { RouteRecordRaw, Router } from 'vue-router'

const ContractRoutes: RouteRecordRaw = {
  path: '/contract/financial',
  name: 'FinancialModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'FinancialRoute',
      component: () => import('./views/FinancialView.vue'),
      meta: {
        title: 'financial.financialContracts',
      },
    },
    {
      path: 'create',
      name: 'CreateFinancialRoute',
      component: () => import('./views/CreateFinancialView.vue'),
      meta: {
        title: 'financial.createFinancial',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:financialId',
      name: 'EditFinancialRoute',
      component: () => import('./views/EditFinancialView.vue'),
      beforeEnter: (to, _, next) => {
        const financialId = to.params.financialId

        if (!financialId || Number.isInteger(Number(financialId))) {
          next()
        } else {
          // FIXME: Redirect to Not Found page
          next({ name: 'FinancialRoute' })
        }
      },
      meta: {
        title: 'financial.EditFinancial',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:financialId',
      name: 'ViewFinancialRoute',
      component: () => import('./views/SingleFinancialView.vue'),
      meta: {
        title: 'financial.ViewFinancial',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(ContractRoutes)
}
